import { useI18n } from 'next-localization';

import { Distance } from '@/components/distance';
import { ModuleLink } from '@/components/module-link/module-link';
import { RedirectProfileState } from '@/features/profile/profile.types';
import { useBasePath } from '@/hooks/use-base-path';
import { useDistanceContext } from '@/hooks/use-distance-context';
import { cn, getPhysicianProfileUrl } from '@/lib/utils';

import styles from '../../listing.module.css';

type HeaderSectionProps = {
  physicianIndex: number;
  totalCount: number;
  urlTitle: string;
  distance: string | null;
  specialty?: string;
  physicianFullNameAndDesignation: string;
  redirectProfileState: RedirectProfileState;
};

export const HeaderSection = ({
  physicianIndex,
  totalCount,
  urlTitle,
  distance,
  specialty,
  physicianFullNameAndDesignation,
  redirectProfileState,
}: HeaderSectionProps): JSX.Element => {
  const { t } = useI18n();
  const { withBasePath } = useBasePath();

  const { setActiveDisplayLocation, setProviderLocations } = useDistanceContext();

  const handleLinkClick = () => {
    setActiveDisplayLocation(redirectProfileState.activeLocation);
    setProviderLocations(redirectProfileState.providerLocations);
  };

  return (
    <div className="col-lg-10 col-md-10 col-8 px-2 px-sm-0">
      <div className="col-12">
        <div className={cn('d-flex', styles.nameWrapper)}>
          <ModuleLink
            href={withBasePath(getPhysicianProfileUrl(urlTitle))}
            onClick={handleLinkClick}
            prefetch={false}
            className={styles.doctorName}
          >
            <span className="sr-only">
              Provider {physicianIndex} of {totalCount}
            </span>
            <span className="sr-only">{t('OAS.LandingPage.ProviderName')} </span>
            {physicianFullNameAndDesignation}
            <span className="sr-only">{t('OAS.LandingPage.ClickToGoProvider')}</span>
          </ModuleLink>
          {distance && (
            <div className={cn('px-2 text-center d-none d-lg-block', styles.distanceDesktop)}>
              <Distance distance={distance} />
            </div>
          )}
        </div>
      </div>

      <div>
        <h6 className={cn('w-100 w-lg-auto', styles.doctorSpecialty)}>
          <span className="sr-only">{t('OAS.Listing.ProviderSpecialty')}:</span>
          {specialty}
        </h6>
      </div>
    </div>
  );
};
